// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'
import { VehicleAlertsAreaId } from './VehicleAlertsAreaId'

const baseRoute = '/vehicle-alerts'

export const BaseVehicleAlertsAreaRoutes = {
  route: baseRoute,
  title: `${VehicleAlertsAreaId}:title`,
  Vehicle: {
    route: '/vehicle',
  },
  InVehicleComponents: {
    route: '/in-vehicle-components',
  },
}

export const VehicleAlertsAreaRoutes = transformRoutes(
  BaseVehicleAlertsAreaRoutes,
)
